import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

// Authenticated pages
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const Monitoring = lazy(() => import("../pages/monitoring/Monitoring"));
const Reports = lazy(() => import("../pages/reports/Reports"));
const ProtectedRoute = lazy(() => import("./ProtectedRoute"));

const authenticatedRoutes = [
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/monitoring",
    element: (
      <ProtectedRoute>
        <Monitoring />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reports",
    element: (
      <ProtectedRoute>
        <Reports />
      </ProtectedRoute>
    ),
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    ),
  },
];

export default authenticatedRoutes;
